export function getJobStatusTranslation(job) {
    if (job.status === 'in_progress') {
        if (job.courierStatus) return `courier_status.${job.courierStatus}`
        else return 'courier_status.searching'
    } else return `delivery_job_status.${job.status}`
}

export function getJobColor(job) {
    let status =
        job.status === 'in_progress'
            ? job.courierStatus || 'searching'
            : job.status
    switch (status) {
        case 'initialized':
        case 'queued':
            return 'g-cc'
        case 'in_progress':
        case 'pending':
        case 'picking':
        case 'almost_picking':
        case 'waiting_at_pickup':
        case 'delivering':
        case 'almost_delivering':
        case 'waiting_at_dropoff':
            return 'accent'
        case 'finished':
        case 'delivered':
        case 'closed':
            return 'success'
        case 'cancelled':
        case 'error':
            return 'error'
        case 'merged':
        case 'grouping':
        case 'searching':
            return 'info'
        default:
            return 'yellow'
    }
}

// DoorDash order-status dots (merchant portal Orders: New / In progress / Ready / Out for delivery), tasks#211.
// The colour of the 12px dot in front of a delivery status, by the courier's progress.
export function deliveryStatusDotColor(status) {
    switch (status) {
        case 'initialized':
        case 'queued':
            return '#b2b2b2'
        case 'searching':
        case 'merged':
        case 'grouping':
        case 'pending':
            return '#00666d'
        case 'in_progress':
        case 'picking':
        case 'almost_picking':
        case 'waiting_at_pickup':
            return '#7f1041'
        case 'delivering':
        case 'almost_delivering':
        case 'waiting_at_dropoff':
            return '#494949'
        case 'finished':
        case 'delivered':
        case 'closed':
            return '#1fa74f'
        case 'cancelled':
        case 'error':
            return '#b71000'
        default:
            return '#d5a600'
    }
}

export function getJobDotColor(job) {
    return deliveryStatusDotColor(
        job.status === 'in_progress'
            ? job.courierStatus || 'searching'
            : job.status
    )
}
